var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hrdate"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"hrdate_date"},[_vm._v(_vm._s(_vm.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }